/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAgentsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAgentsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAgentsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentsSecurity$outboundSchema: z.ZodMiniType<
  ListAgentsSecurity$Outbound,
  ListAgentsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAgentsSecurityToJSON(
  listAgentsSecurity: ListAgentsSecurity,
): string {
  return JSON.stringify(
    ListAgentsSecurity$outboundSchema.parse(listAgentsSecurity),
  );
}

/** @internal */
export type ListAgentsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentsRequest$outboundSchema: z.ZodMiniType<
  ListAgentsRequest$Outbound,
  ListAgentsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listAgentsRequestToJSON(
  listAgentsRequest: ListAgentsRequest,
): string {
  return JSON.stringify(
    ListAgentsRequest$outboundSchema.parse(listAgentsRequest),
  );
}
